import Vue from 'vue'
import moment from 'moment'

moment.locale('es')

Vue.filter('currency', value => {
  // If the value is not a number, return the value as is
  if (isNaN(value)) return value;

  // Convert the value to a fixed decimal string
  value = Number(value).toFixed(2);

  // Split the value into whole and decimal parts
  let [whole, decimal] = value.split('.');

  // Add dot every 3 digits in the whole part
  whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Return the formatted currency string, removing decimal part if it's '00'
  return decimal === '00' ? `$ ${whole}` : `$ ${whole},${decimal}`;
});

Vue.filter('money', input => input.toLocaleString('es-ES', {minimumFractionDigits: 2}))

Vue.filter('nosymbol', amount =>
  amount && amount.replace ? amount.replace(/\$/g, '') : amount)

Vue.filter('capitalize', input => {
  if (!input) return ''

  const capitalizeWord = word => word.charAt(0).toUpperCase() + word.slice(1)

  const lowerCasedWords = input.toLowerCase().trim().split(' ')

  return lowerCasedWords.map(capitalizeWord).join(' ')
})

Vue.filter('moment', date => date ? moment(date).fromNow() : '')

Vue.filter('date', timestamp => {
  const ts = new Date(timestamp)
  const pad = num => num.toString().padStart(2, '0')

  return isNaN(ts) ? ''
    : `${pad(ts.getDate())}/${pad(ts.getMonth() + 1)}/${ts.getFullYear()}`
})

Vue.filter('shortDate', date => date
  .replace(/^(\d{1,2})\/(\d{1,2})\/(\d{2})(\d{2})$/, '$2/$4'))

Vue.filter('stripHTML', function (value) {
  const div = document.createElement('div')
  div.innerHTML = value
  const text = div.textContent || div.innerText || ''
  return text.replace(/\u00a0/g, "")
})



// WEBPACK FOOTER //
// ./src/filters.js